import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {IHomeWork} from "../../../constants/ILMS";

interface IFilter {
    projectId?: string,
    themeId?: string,
    groupId?: string
}

export const useGetHomeWork = (request: IFilter, lang: string, t?: number, disabled?: boolean) =>  {
        const [resp, setResp] = useState<IHomeWork[]>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {

            if (!request?.projectId || !request?.themeId || disabled) return;

                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url('/api/LMS/GetHomeWorks')
                    .get()
                    .addQuery('moduleProjectId', request?.projectId)
                    .addQuery('themeLongreadId', request?.themeId)
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        if (r?.status === 400 || r?.status === 403) {
                            return;
                        }
                        setResp(API.toLang(r, lang))
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
        }, [request?.projectId, request?.themeId, request?.groupId, lang, t, disabled])

        return {homeWork: resp, isLoading, error};
    }import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {IHomeWork} from "../../../constants/ILMS";

interface IFilter {
    projectId?: string,
    themeId?: string,
    groupId?: string
}

export const useGetHomeWork = (request: IFilter, lang: string, t?: number, disabled?: boolean) =>  {
        const [resp, setResp] = useState<IHomeWork[]>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {

            if (!request?.projectId || !request?.themeId || disabled) return;

                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url('/api/LMS/GetHomeWorks')
                    .get()
                    .addQuery('moduleProjectId', request?.projectId)
                    .addQuery('themeLongreadId', request?.themeId)
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        if (r?.status === 400 || r?.status === 403) {
                            return;
                        }
                        setResp(API.toLang(r, lang))
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
        }, [request?.projectId, request?.themeId, request?.groupId, lang, t, disabled])

        return {homeWork: resp, isLoading, error};
    }